import React, { useEffect } from 'react';
import ContactScrollLink from './contact/ContactScrollLink';
import './ProjectKubelikova.css';

const imageBase = 'https://storagecleverbasic.blob.core.windows.net/p4lgroup-data/kubelikova/';

const gallery = [
    { src: `${imageBase}interier4.jpg`, alt: 'Interiér projektu Kubelíkova' },
    { src: `${imageBase}kubelikova-gallery8.jpg`, alt: 'Fotografie projektu Kubelíkova' },
    { src: `${imageBase}interier1.jpg`, alt: 'Další interiér projektu Kubelíkova' }
];

function ProjectKubelikova() {
    useEffect(() => {
        if (window.location.hash === '#projekt-kubelikova') {
            document.getElementById('projekt-kubelikova').scrollIntoView();
        }
    }, []);

    return (
        <section id="projekt-kubelikova" className="kubelikova-section" aria-labelledby="kubelikova-title">
            <div className="container">
                <div className="kubelikova-heading">
                    <span className="kubelikova-eyebrow">Dokončený developerský projekt · Liberec</span>
                    <h2 id="kubelikova-title">Kubelíkova</h2>
                    <p>Dokončený projekt rodinného trojdomu v Liberci. Zkušenost, na kterou chci navázat při přípravě dalších menších developerských projektů.</p>
                </div>

                <div className="kubelikova-feature">
                    <a className="kubelikova-feature-image" href={`${imageBase}kubelikova-gallery5.jpg`} target="_blank" rel="noopener noreferrer">
                        <img src={`${imageBase}kubelikova-gallery5.jpg`} alt="Fotografie projektu Kubelíkova v Liberci" loading="lazy" />
                    </a>
                    <div className="kubelikova-feature-content">
                        <span className="kubelikova-eyebrow">O projektu</span>
                        <h3>Rodinný trojdům v Liberci</h3>
                        <p>
                            Ve spolupráci se společností Souz jsem v Kubelíkově ulici dokončil projekt
                            rodinného trojdomu. Projekt zahrnuje tři domy Canaba UNO City, každý s dispozicí
                            4+1, podlahovou plochou 96 m² a vlastním parkovacím místem.
                        </p>
                        <p>
                            Zkušenosti z Kubelíkovy využívám při prověřování dalších pozemků, přípravě
                            výstavby a hledání vhodných forem spolupráce s vlastníky a investory.
                        </p>
                        <ContactScrollLink className="rn-button-style--2 btn-solid kubelikova-contact" subject="Pozemek nebo developerský projekt">
                            <span>Probrat další projekt</span>
                        </ContactScrollLink>
                    </div>
                </div>

                <div className="kubelikova-gallery" aria-label="Fotografie projektu Kubelíkova">
                    {gallery.map(image => (
                        <a className="kubelikova-gallery-image" href={image.src} target="_blank" rel="noopener noreferrer" key={image.src}>
                            <img src={image.src} alt={image.alt} loading="lazy" />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ProjectKubelikova;
